import { defineStyle, defineStyleConfig, ComponentStyleConfig } from '@chakra-ui/react';

const baseStyle = defineStyle({
  borderRadius: 'base',
  px: 2,
  py: 1,
  boxShadow: 'xs',
});

export const tooltipTheme: ComponentStyleConfig = defineStyleConfig({
  baseStyle,
});
